import request from "@/utils/request";

export const queryDocuments = (id: string, type: any, breviary: boolean) =>
    request({
        url: `/documents-stream/${id}?type=${type}&breviary=${breviary}`,
        method: "get",
    });

export const shipmentPosition = (id: string) =>
    request({
        url: `/documents-stream/shipment-position?hqPackingListId=${id}`,
        method: "get",
    });
// /documents-stream/v2
// documentsId
// type
// action
export const getDocumentsStreamV2 = (params: any) =>
  request({
    url: `/documents-stream/v2`,
    method: "get",
    params
  });